import { Box, styled } from "@mui/material";
import { cloneElement, isValidElement, ReactNode } from "react";

export const ANALYTICS_STAT_CARD_ICON_SIZE = 18;

const StatCardIconBox = styled(Box)(({ theme }) => ({
  width: 32,
  height: 32,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "rgba(255,255,255,0.95)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 2px 8px rgba(0,0,0,0.12)",
  color: theme.palette.primary.main,
  flexShrink: 0,
}));

function sizedIcon(icon: ReactNode): ReactNode {
  if (!isValidElement(icon)) {
    return icon;
  }

  const props = icon.props as { sx?: object };
  return cloneElement(icon, {
    sx: { fontSize: ANALYTICS_STAT_CARD_ICON_SIZE, ...props.sx },
  } as never);
}

export interface AnalyticsStatCardIconProps {
  icon?: ReactNode;
  noBg?: boolean;
}

function AnalyticsStatCardIcon({ icon, noBg }: AnalyticsStatCardIconProps) {
  if (!icon) {
    return null;
  }

  const content = sizedIcon(icon);

  if (noBg) {
    return <Box sx={{ flexShrink: 0, color: "primary.main" }}>{content}</Box>;
  }

  return <StatCardIconBox>{content}</StatCardIconBox>;
}

export default AnalyticsStatCardIcon;
